/* eslint-disable import/no-default-export */
import Chance from 'chance';

import { baseQualificationCredential } from './BaseQualificationCredential';

const chance = new Chance();

export default () => {
  const completed = chance.bool();

  return {
    id: chance.guid(),
    name: () => ({
      text: chance.pickone([
        'Bachelor of Computer Stuff',
        'Diploma of Googling',
        'Certficate IV in GraphQL',
      ]),
      ontologyId: chance.url(),
    }),
    level2: () => chance.pickone(['Postgraduate', 'Degree', 'Diploma']),
    institute: () => ({
      text: chance.pickone([
        'Melbourne University',
        'Monash',
        'RMIT',
        'Swinburne',
      ]),
      ontologyId: chance.url(),
    }),
    completed,
    completionDate: () =>
      completed
        ? {
            __typename: 'Year',
            year: chance.natural({
              min: 1990,
              max: 2015,
            }),
          }
        : {
            __typename: 'MonthYear',
            month: chance.natural({ min: 1, max: 12 }),
            year: chance.natural({
              min: 2000,
              max: 2025,
            }),
          },
    highlights: () => chance.paragraph(),
    formattedCompletion: chance.pickone([
      'In progress',
      'Finished 1992',
      'Finished',
      'Expected finish Oct 2030',
    ]),
    status: chance.d4() === 1 ? null : 'New',
    tracking: {
      events: [{ key: 'served', value: chance.guid() }],
    },
    credential: chance.bool() ? baseQualificationCredential : null,
  };
};
